module.exports = __webpack_public_path__ + "media/images/location-icon-6bdef4753706c1609d640ccbb75163af.png";